<template>
  <section v-on:click="sectionClicked" class="sectionMap"
    :class="{features: !section.wideScreen}">
    <div :class="{cnt: !section.wideScreen}" class="mapboxWrapper">
      <div class="mapboxCnt loading" v-if="section.loading"></div>
      <div class="mapboxCnt" v-else>
        <MglMap
          :accessToken="mapAccessToken"
          :mapStyle="section.mapboxStyle === 'Custom' ? section.customStyle : section.mapboxStyle" :attributionControl="section.attribution"
          :interactive="section.interactive" v-on:load="onMapLoaded"
          :center="[section.lng, section.lat]"
          :zoom="Number(section.zoom)" :scrollZoom="false">
          <MglAttributionControl position="top-left"
            :customAttribution="section.attributionLabel[lang]"
            v-if="section.attribution"/>
          <MglFullscreenControl position="top-right" v-if="section.fullScreen"/>
          <template v-if="section.showControl">
            <MglNavigationControl position="top-right"/>
            <MglGeolocateControl position="top-right"/>
            <MglScaleControl position="bottom-right"/>
          </template>

          <MglPopup :coordinates='[section.lng, section.lat]' :showed='true'>
            <div class="popup">
              I'm the popup content
            </div>
          </MglPopup>
          <MglPopup :coordinates="[section.lng, section.lat]" anchor="top">
            <div>Hello, I'm popup!</div>
          </MglPopup>

          <MglMarker v-for="(marker, i) in markers" :key="`mk${i}`"
            :coordinates="marker.coordinates" :color="marker.color"
            :anchor="marker.anchor" v-on:click="markerClicked($event, marker)">
            <MglPopup>
              <div class="popup" slot="popup">Aduhai boss</div>
            </MglPopup>
            <template v-if="((marker.title && marker.title[lang])
              || (marker.descriptions && marker.descriptions[lang]))">
              <div class="marker-popup" slot="popup">
                <h4 v-if="marker.title && marker.title[lang]">{{marker.title[lang]}}</h4>
                <p v-if="marker.descriptions && marker.descriptions[lang]">
                  {{marker.descriptions[lang]}}</p>
              </div>
            </template>
          </MglMarker>
        </MglMap>
      </div>
    </div>
  </section>
</template>

<script>
import Mapbox from 'mapbox-gl';
import {
  MglMap,
  MglAttributionControl,
  MglNavigationControl,
  MglGeolocateControl,
  MglFullscreenControl,
  MglScaleControl,
  MglMarker,
  MglPopup,
} from 'vue-mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
  name: 'home',
  props: ['section'],
  components: {
    MglMap,
    MglAttributionControl,
    MglNavigationControl,
    MglGeolocateControl,
    MglFullscreenControl,
    MglScaleControl,
    MglMarker,
    MglPopup,
  },
  data() {
    return {
      geojson: null,
      markers: [],
      mapAccessToken: 'pk.eyJ1IjoiYWN0aW9ubGFiIiwiYSI6ImNsMDN3NzRvdTBsMzQzbXFiM2c3Y29oOG4ifQ.5zEwWaVkWt1r38tMa8CGTA',

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    markerClicked(e, marker) {
      setTimeout(() => {
        if ((marker.title && marker.title[this.lang])
          || (marker.descriptions && marker.descriptions[this.lang])) {
          let elStr = '';
          if (marker.image && marker.image[this.lang]) elStr += `<img src="${marker.image[this.lang]}">`;
          if (marker.title && marker.title[this.lang]) elStr += `<h4>${marker.title[this.lang]}</h4>`;
          if (marker.descriptions && marker.descriptions[this.lang]) elStr += `<p>${marker.descriptions[this.lang]}</p>`;
          if (marker.url) {
            elStr += `<a class="btn outline" href="${marker.url}" target="_blank">`;
            if (marker.buttonLabel && marker.buttonLabel[this.lang]) {
              elStr += marker.buttonLabel[this.lang];
            } else {
              elStr += 'Lear More';
            }
            elStr += '</a>';
          }
          new Mapbox.Popup({ className: 'cst-marker-popup' })
            .setLngLat(marker.coordinates)
            .setHTML(elStr)
            .setMaxWidth('340px')
            .addTo(e.map);
        }
      });
    },
    onMapLoaded(e) {
      if (this.geojson) {
        e.map.addSource('mygeojson', {
          type: 'geojson',
          data: this.geojson,
        });

        e.map.addLayer({
          id: 'myfill',
          type: 'fill',
          source: 'mygeojson',
          layout: {},
          filter: ['==', ['geometry-type'], 'Polygon'],
          paint: {
            'fill-color': ['coalesce', ['get', 'fill'], '#008552'],
            'fill-opacity': ['coalesce', ['get', 'fill-opacity'], 0.2],
          },
        });

        e.map.addLayer({
          id: 'myline',
          type: 'line',
          source: 'mygeojson',
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': ['coalesce', ['get', 'stroke'], '#008552'],
            'line-width': ['coalesce', ['get', 'stroke-width'], 3],
            'line-opacity': ['coalesce', ['get', 'stroke-opacity'], 1],
          },
        });

        e.map.on('click', 'myfill', (ev) => {
          /**
           * TODO Display popup here
           *
           */
        });

        e.map.on('click', 'myline', (ev) => {
          /**
           * TODO Display popup here
           *
           */
        });
      }
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    if (this.section.geojson) {
      try {
        this.geojson = JSON.parse(this.section.geojson);
        this.geojson.features.forEach((item) => {
          if (item.geometry.type !== 'Point') return;
          const marker = {
            color: item.properties['marker-color'],
            coordinates: item.geometry.coordinates,
            anchor: 'bottom',
            title: {
              id: item.properties['title[id]'],
              en: item.properties['title[en]'],
            },
            descriptions: {
              id: item.properties['descriptions[id]'],
              en: item.properties['descriptions[en]'],
            },
            image: {
              id: item.properties['image[id]'],
              en: item.properties['image[en]'],
            },
            url: item.properties.url,
            buttonLabel: {
              id: item.properties['button-label[id]'],
              en: item.properties['button-label[en]'],
            },
          };
          this.markers.push(marker);
        });
      } catch (err) {
        // eslint-disable-next-line
        console.error('Unable to parse geojson', err);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.mapboxCnt{
  position: relative;
  height: 480px;
  z-index: 12;
  margin: 0 auto;
  &.loading{
    background-image: url(../../assets/loading.svg);
    background-size: 46px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.mapboxWrapper.cnt .mapboxCnt{
  border-radius: 10px;
  overflow: hidden;
  height: 400px;
  max-width: 840px;
}
</style>
